import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import {
  IObradiSefRacunCommand,
  IRelevantniDokumentListItemUrlDto,
  IStavkaRacunaDto,
  NeobradjenRacunDto,
  ObradaFormRequest,
  ObradiSefRacunCommand,
  RacunDto,
  RacuniClient,
  SefClient,
  StatusRacuna,
  TipRacuna,
  TipRelevantnogDokumenta,
  VrstaFakture,
  VrstaRacuna,
  ZavisniTrosakStavkaDto
} from '@kodit/core/data-api';
import {
  AlertService,
  ensureFileUrl,
  LocationService,
  RacunForm,
  RacunService,
  SharedService,
  TIP_RACUNA_TO_TIP_ENTITETA
} from '@kodit/core/services';
import { FormBuilderTypeSafe, FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { FormHelper } from '@kodit/core/form-definitions';
import { DynamicDialogConfig, DynamicDialogRef, DynamicDialogService } from '@kodit/core/shared-ui';
import {
  OdobravanjeOdbacivanjeRacunaFormComponent
} from '../../../../../../shared-subforms/src/lib/racun/neobradjeni-racuni/odobravanje-odbacivanje-racuna-form/odobravanje-odbacivanje-racuna-form.component';
import {
  DialogSize,
  OnDynamicDialogInit
} from '../../../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { LoaderService } from '../../../../../../shared-ui/src/lib/loader/loader.service';
import { finalize } from 'rxjs/operators';
import { FormArray, FormControl } from '@angular/forms';
import { BaseRacunFormService } from '../../../../../../form-definitions/src/lib/racun/_base_racun-form.service';

@Component({
  selector: 'kodit-neobradjen-racun-form',
  templateUrl: './neobradjen-racun-form.component.html',
  styleUrls: ['./neobradjen-racun-form.component.scss'],
})
export class NeobradjenRacunFormComponent
  implements OnInit, OnDestroy, OnDynamicDialogInit {
  /** Props */
  racunDto: RacunDto;
  neobradjenRacun: NeobradjenRacunDto;
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);
  showOdobriOdbaci: boolean;
  pdfFileUrl: string;
  isAutomatski: boolean;
  racunForm: FormGroupTypeSafe<IObradiSefRacunCommand>;
  dokumentOSmanjenjuValue: TipRacuna = TipRacuna.DOKUMENT_O_SMANJENJU;
  relevantniDokumenti: IRelevantniDokumentListItemUrlDto[] = [];
  private _subs: Subscription = new Subscription();
  shouldDisableObradi = false;

  constructor(
    private _client: SefClient,
    private _racunClient: RacuniClient,
    private _alertService: AlertService,
    private _route: ActivatedRoute,
    private _domSanitizer: DomSanitizer,
    private _service: RacunService,
    private _locationService: LocationService,
    private _formHelper: FormHelper,
    private _dialogService: DynamicDialogService,
    private _loader: LoaderService,
    private _fs: FormBuilderTypeSafe,
    private _baseRacunForm: BaseRacunFormService,
    private _racunService: RacunService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    const formConfiguration = this._route.snapshot.data.formConfiguration;
    if (
      this._route.snapshot.data.neobradjenRacun instanceof ObradaFormRequest
    ) {
      this.neobradjenRacun = this._route.snapshot.data.neobradjenRacun.neobradjenRacunDto;
      this.racunDto = this._route.snapshot.data.neobradjenRacun.racunDto;
      this.isAutomatski = true;
    } else {
      this.neobradjenRacun = this._route.snapshot.data.neobradjenRacun;
    }

    this._getRelevantneDokumente();

    this.showOdobriOdbaci =
      this.neobradjenRacun.statusRacuna === StatusRacuna.NOVO ||
      this.neobradjenRacun.statusRacuna ===
        StatusRacuna.PODSETNIK_PONOVO_POSLAT ||
      this.neobradjenRacun.statusRacuna === StatusRacuna.PREGLEDANO ||
      this.neobradjenRacun.statusRacuna === StatusRacuna.PRIMLJENO;

    this.racunForm = this._fs.group<IObradiSefRacunCommand>({
      brojFiskalnogIsecka: new FormControl(),
      racunDto: this.isAutomatski
        ? this._baseRacunForm.GetBaseRacunFormGroup(
            this.neobradjenRacun.tipRacunaDto.tip,
            VrstaRacuna.ULAZNI,
            TIP_RACUNA_TO_TIP_ENTITETA[this.neobradjenRacun.tipRacunaDto.tip],
            formConfiguration,
            this.racunDto
          )
        : this._service.initRacunFormFromNeobradjenRacun(
            this.neobradjenRacun,
            formConfiguration
          ),
      sefId: new FormControl(this.neobradjenRacun.sefId),
      vrstaFakture: new FormControl(VrstaFakture.DOMACA),
    });

    this._racunService.setRacunForm = this.racunForm.controls.racunDto as unknown as RacunForm;
  }

  handleObradi() {
    console.log(this.racunForm.value);

    this._service.handleStavkeByZavisniTroskovi();

    // check is it valid
    if (!this.isValid()) {
      console.log(this.racunForm);
      // check all stavke pdv da li se poklapaju
      let invalidStavke = this.getInvalidStavke();
      for (const { stavka, index } of invalidStavke) {
        if (
          stavka.pdvStopa !==
          this.racunForm.value.racunDto.stavkeDto[index].stopaPDV
        ) {
          this._alertService.addWarnMsg(
            `Nije moguće vezivanje za ${
              index + 1
            }. stavku. PDV stope se ne podudaraju.`
          );
          return;
        }
      }
      this._formHelper.invalidateForm(this.racunForm);
      return;
    }

    // Popunjavamo stavku zbog racunanja na BE
    (this.racunForm.controls.racunDto.get(
      'stavkeDto'
    ) as FormArray).value.forEach((stavka: IStavkaRacunaDto) => {
      stavka.prodajnaCenaBezPdv = stavka.predmetStavkeDto.prodajnaCenaBezPdv;
      stavka.stopaPDV = stavka.predmetStavkeDto.stopaPDV;
    });

    this._loader.setLoadingText = 'Obrađujem ulazni račun...';
    this._loader.setShowLoader = true;

    const req = this.racunForm.value as ObradiSefRacunCommand;
    req.zavisniTroskoviStavkeDto = this._service
      .getZavisneTroskove as ZavisniTrosakStavkaDto[];

    this._subs.add(
      this._client
        .obradi(req)
        .pipe(
          finalize(() => {
            this._loader.reset();
          })
        )
        .subscribe((res) => {
          if (res.succeeded) {
            this._alertService.addSuccessMsgs(res.messages);
            this._locationService.routeBack();
          } else {
            this._alertService.addFailedMsgs(res.messages);
          }
        })
    );
  }

  isValid() {
    if (this.racunForm.valid) {
      return true;
    }
    const zavisniTroskoviRedniBrojevi = this._service.getZavisneTroskove
      .filter((x) => x.redniBroj)
      .map((x) => Number(x.redniBroj));

    return this.racunForm.value.racunDto.stavkeDto.every((x) =>
      zavisniTroskoviRedniBrojevi.includes(x.redniBroj)
    );
  }

  getInvalidStavke() {
    const zavisniTroskoviRedniBrojevi = this._service.getZavisneTroskove
      .filter((x) => x.redniBroj)
      .map((x) => x.redniBroj);

    return this.neobradjenRacun.stavkeDto
      .map((stavka, index) => ({ stavka, index }))
      .filter((x) => !zavisniTroskoviRedniBrojevi.includes(x.stavka.redniBroj));
  }

  onReturn() {
    this._locationService.routeToRacunTable(
      TipRacuna.ULAZNA_FAKTURA,
      VrstaRacuna.ULAZNI,
      0
    );
  }

  openDialog(config: DynamicDialogConfig) {
    config.customSubmitButton = {
      icon: 'fas fa-save',
      label: 'Da',
      class: 'mw-90',
    };
    config.customCancelButton = {
      icon: 'far fa-window-close',
      label: 'Ne',
    };
    let ref: DynamicDialogRef = this._dialogService.open(
      OdobravanjeOdbacivanjeRacunaFormComponent,
      config
    );

    this._subs.add(
      ref.onClose.subscribe((res?: boolean) => {
        if (res) {
          this._locationService.routeToRacunTable(
            TipRacuna.ULAZNA_FAKTURA,
            VrstaRacuna.ULAZNI,
            0
          );
        } else if (res === false) {
          this._locationService.routeToRacunTable(
            TipRacuna.ULAZNA_FAKTURA,
            VrstaRacuna.ULAZNI,
            0
          );
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
    this._service.resetService();
  }

  private _getRelevantneDokumente() {
    this._subs.add(
      this._racunClient
        .getRelevantneDokumente(this.racunDto.id)
        .subscribe((res) => {
          if (res.succeeded) {
            this.relevantniDokumenti = res.data.responseList;
            this._setPdfFromStorage(
              res.data.responseList.find(
                (x) =>
                  x.tipRelevantnogDokumenta ===
                    TipRelevantnogDokumenta.FAKTURA_RS ||
                  x.tipRelevantnogDokumenta ===
                    TipRelevantnogDokumenta.SEF_FAKTURA_RS
              ).storageFileName
            );
          }
          // ako res nije succeeded, znaci da nemamo nista u storage,a trebali bismo pa uploadujemo
          else {
            this._sharedService.displayLoadingScreen(
              true,
              'Pribavljanje dokumenata...'
            );
            this._subs.add(
              this._racunClient
                .uploadMissingPdf(this.racunDto.id)
                .pipe(
                  finalize(() => {
                    this._sharedService.resetLoadingScreen();
                  })
                )
                .subscribe((res) => {
                  if (res.succeeded) {
                    this.relevantniDokumenti = res.data
                      .responseList as IRelevantniDokumentListItemUrlDto[];
                    this.pdfFileUrl = ensureFileUrl(
                      res.data.responseList.find(
                        (x) =>
                          x.tipRelevantnogDokumenta ==
                          TipRelevantnogDokumenta.FAKTURA_RS
                      ).fileUrl
                    );
                  }
                })
            );
          }
        })
    );
  }

  private _setPdfFromStorage(originalFileName: string) {
    if (!originalFileName) {
      this._alertService.addWarnMsg('Ne postoji podrazumevani pdf fajl');
      return;
    }

    this._subs.add(
      this._racunClient
        .getRelevantniDokumentUrl(originalFileName)
        .subscribe((res) => {
          this.pdfFileUrl = ensureFileUrl(res.data.fileUrl);
        })
    );
  }
}
